import React from 'react';

import PropTypes from 'prop-types';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const FailedUnavailableAddressModal = ({ modalRef, json, formName, fields, mainText, topButtonCaption, topButtonLink, changeFormFieldValue }) => {
    const handleTryAgain = () => {
        changeFormFieldValue(formName, '', fields?.address?.name);
        modalRef?.current?.close();
    };

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                iconName={'alert-circle-80'}
                iconColor="primary"
                animatedIconFail
                mainText={mainText}
                headerText={json?.messages?.errorTitle}
                secondaryText={json?.messages?.errorText}
                topButtonType="link"
                topButtonCaption={topButtonCaption}
                topButtonLink={topButtonLink}
                primaryButtonType="button"
                primaryButtonCaption={json?.messages?.tryAgain}
                primaryButtonOnClick={handleTryAgain}
            />
        </ModalComponent>
    );
};

FailedUnavailableAddressModal.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    json: PropTypes.object,
    formName: PropTypes.string.isRequired,
    fields: PropTypes.object,
    mainText: PropTypes.string,
    topButtonCaption: PropTypes.string,
    topButtonLink: PropTypes.string,
    changeFormFieldValue: PropTypes.func.isRequired,
};

export default FailedUnavailableAddressModal;
